import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import ReactTable from "react-table";
import { decimalAdjust } from "../../Global";
import { EditableNumericInput, EditableSelect } from './Inputs';
import moment from 'moment';

function IngresoTable(props) {
    const [rows, setRows] = useState([]);

    useEffect(() => {
        if (props.data) {
            setRows(props.data.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase())));
        }
    }, [props.data]);

    const displayedRows = rows;

    const handleValueChange = useCallback((item, fieldName, newValue) => {
        if (props.handleValueChange) {
            props.handleValueChange(item, fieldName, newValue);
        }
    }, [props.handleValueChange]);

    const handleDelete = useCallback((item) => {
        if (props.handleDelete) {
            props.handleDelete(item);
        }
    }, [props.handleDelete]);

    const calculateTotal = useCallback((cantidad, precioCosto) => {
        return decimalAdjust('floor', cantidad * precioCosto, -2);
    }, []);

    const calculateUtilidadBruta = useCallback((cantidad, precioVenta, precioCosto, bonificado = 0) => {
        const totalVenta = cantidad * precioVenta;
        const totalCosto = cantidad * precioCosto;
        const bonificadoCosto = bonificado * precioCosto;
        return decimalAdjust('floor', totalVenta - totalCosto - bonificadoCosto, -2);
    }, []);

    const columns = useMemo(() => [
        {
            Header: "",
            accessor: "action",
            maxWidth: 80,
            Cell: row => (
                <div style={{ textAlign: "center" }}>
                    <button
                        onClick={() => handleDelete(row.original)}
                        style={{
                            backgroundColor: '#dc3545',
                            color: 'white',
                            border: 'none',
                            padding: '5px 10px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: 'bold'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#c82333'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#dc3545'}
                        title="Eliminar item"
                    >
                        ✕
                    </button>
                </div>
            )
        },
        {
            Header: "Producto",
            accessor: "label",
            minWidth: 200,
            Cell: row => (
                <div style={{ fontWeight: 'bold' }}>
                    {row.value}
                </div>
            )
        },
        {
            Header: "Tipo Transacción",
            accessor: "idTipoTransaccion",
            width: 150,
            Cell: row => (
                <div style={{ fontWeight: 'bold'}}>
                    {props.tiposTransaccion.find(x => x.IdTipoTransaccionAlmacen == row.value)?.DescripcionCorta}
                </div>
            )
        },
        {
            Header: "Cod. Lote",
            accessor: "CodLote",
            width: 180,
            show: props.sucursal.Abastecimiento,
            Cell: row => (
                <div style={{ textAlign: "right" }}>
                    <EditableSelect
                        item={row.original}
                        initialValue={row.value}
                        onValueChange={handleValueChange}
                        fieldName="CodLote"
                        options={(row.original.CodigosLote || []).map(item => ({
                            value: item.IdLote,
                            label: `${item.Codigo} - F.V: ${moment(item.FechaVencimiento).format("DD/MM/YYYY")}`
                        }))}
                    />
                </div>
            )
        },
        {
            Header: "Cantidad",
            accessor: "Cantidad",
            width: 70,
            Cell: row => (
                <div style={{ textAlign: "right" }}>
                    <EditableNumericInput
                        item={row.original}
                        initialValue={row.value}
                        onValueChange={handleValueChange}
                        fieldName="Cantidad"
                        step="1"
                        min="0"
                    />
                </div>
            )
        },
    ], [handleValueChange, calculateTotal, calculateUtilidadBruta, handleDelete]);

    return (
        <div>
            <ReactTable
                data={displayedRows}
                disabled={false}
                columns={columns}
                defaultPageSize={Math.max(displayedRows.length, 1)}
                pageSize={displayedRows.length}
                showPagination={false}
                style={{
                    height: "auto",
                    width: "100%",
                    fontSize: "13px"
                }}
                className="-striped -highlight"
                minRows={0}
            />
        </div>
    );
}

export default IngresoTable;
